import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRobot = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M4 9C4 8.44772 4.44772 8 5 8H19C19.5523 8 20 8.44772 20 9V20C20 20.5523 19.5523 21 19 21H5C4.44772 21 4 20.5523 4 20V9ZM6 10V19H18V10H6Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.5 13.25C10.5 13.9404 9.94036 14.5 9.25 14.5C8.55964 14.5 8 13.9404 8 13.25C8 12.5596 8.55964 12 9.25 12C9.94036 12 10.5 12.5596 10.5 13.25Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6 14C6 15.1046 5.10457 16 4 16C2.89543 16 2 15.1046 2 14C2 12.8954 2.89543 12 4 12C5.10457 12 6 12.8954 6 14Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M22 14C22 15.1046 21.1046 16 20 16C18.8954 16 18 15.1046 18 14C18 12.8954 18.8954 12 20 12C21.1046 12 22 12.8954 22 14Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M12 5C11.7239 5 11.5 5.22386 11.5 5.5C11.5 5.77614 11.7239 6 12 6C12.2761 6 12.5 5.77614 12.5 5.5C12.5 5.22386 12.2761 5 12 5ZM9.5 5.5C9.5 4.11929 10.6193 3 12 3C13.3807 3 14.5 4.11929 14.5 5.5C14.5 6.88071 13.3807 8 12 8C10.6193 8 9.5 6.88071 9.5 5.5Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16 13.25C16 13.9404 15.4404 14.5 14.75 14.5C14.0596 14.5 13.5 13.9404 13.5 13.25C13.5 12.5596 14.0596 12 14.75 12C15.4404 12 16 12.5596 16 13.25Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M9 17C9 16.4477 9.44772 16 10 16H14C14.5523 16 15 16.4477 15 17C15 17.5523 14.5523 18 14 18H10C9.44772 18 9 17.5523 9 17Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M12 6C12.5523 6 13 6.44772 13 7V9C13 9.55228 12.5523 10 12 10C11.4477 10 11 9.55228 11 9V7C11 6.44772 11.4477 6 12 6Z",
			fill: "currentColor"
		})
	]
});
export default SvgRobot;
